import ComponentCheckbox from '../../../components/ComponentCheckbox'
import {getIn, useFormikContext} from 'formik'
import React, {FC} from 'react'
import {useIntl} from 'react-intl'

export const FieldPrintToggle: FC<{path: string}> = ({path}) => {
    const {values, setFieldValue} = useFormikContext<any>()
    const intl = useIntl()
    const checked = !!getIn(values, path)
    return (
        <div className='moduleForm_field_printToggle'>
            <ComponentCheckbox
                label={intl.formatMessage({id: 'FIELD.FOR_PRINT'})}
                customChecked={checked}
                customHandler={() => setFieldValue(path, !checked)}
                buttonLike
                hoverLabel
            />
        </div>
    )
}
